import { Fragment } from "react";
import { parseRefs } from "../agent/RefText";
import { CitationChip } from "./CitationChip";

/**
 * Renders AI copy that embeds [ref:type:id] markers, turning each into a mono
 * teal CitationChip. Reuses RefText's parseRefs (the single ref parser).
 */
export function AgentText({ text }: { text: string }) {
  const segments = parseRefs(text);
  return (
    <>
      {segments.map((seg, i) =>
        seg.kind === "text" ? (
          <Fragment key={i}>{seg.text}</Fragment>
        ) : (
          <CitationChip key={i} type={seg.type} id={seg.id} />
        ),
      )}
    </>
  );
}
